export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <div className="max-w-2xl mx-auto text-center bg-background-100 rounded-2xl p-8 md:p-12 border border-background-200/70">
          <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-100">
            <span className="w-8 h-8 flex items-center justify-center text-primary-500">
              <i className="ri-mail-send-line text-2xl"></i>
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            投稿 / 爆料
          </h2>
          <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto">
            你有独家爆料或精彩内容想要分享？欢迎向91吃瓜群众社区投稿。
            我们珍视每一位吃瓜群众的贡献，优质内容将获得首页推荐机会。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="mailto:tougao@91chigua.com"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap text-sm cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line text-sm"></i>
              </span>
              邮件投稿
            </a>
            <a
              href="#about"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 text-foreground-700 font-medium rounded-full border border-background-300 hover:border-primary-300 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap text-sm cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-information-line text-sm"></i>
              </span>
              了解更多
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}